import { createSlice } from "@reduxjs/toolkit";
import {
  getAllContactEnquiriesThunk,
  getSingleContactEnquiryThunk,
  addContactEnquiryThunk,
  updateContactEnquiryThunk,
  deleteContactEnquiryThunk,
} from "./thunk";

const initialState = {
  contactUs: [],
  singleEnquiry: null,
  loading: false,
  error: null,
  successMessage: null,
};

const contactUsSlice = createSlice({
  name: "contactUs",
  initialState,
  reducers: {
    clearContactUsState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder

      /* -------------------- ALL CONTACT ENQUIRIES -------------------- */
      .addCase(getAllContactEnquiriesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllContactEnquiriesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.contactUs = action.payload?.data || [];
      })
      .addCase(getAllContactEnquiriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- SINGLE CONTACT ENQUIRY -------------------- */
      .addCase(getSingleContactEnquiryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleContactEnquiryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singleEnquiry = action.payload?.data || null;
      })
      .addCase(getSingleContactEnquiryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- ADD CONTACT ENQUIRY -------------------- */
      .addCase(addContactEnquiryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(addContactEnquiryThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Contact enquiry added successfully!";
      })
      .addCase(addContactEnquiryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- UPDATE CONTACT ENQUIRY -------------------- */
      .addCase(updateContactEnquiryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(updateContactEnquiryThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Contact enquiry updated successfully!";
      })
      .addCase(updateContactEnquiryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- DELETE CONTACT ENQUIRY -------------------- */
      .addCase(deleteContactEnquiryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(deleteContactEnquiryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.contactUs = state.contactUs.filter(
          (item) => item.uuid !== action.payload.uuid
        );
        state.successMessage = "Contact enquiry deleted successfully!";
      })
      .addCase(deleteContactEnquiryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearContactUsState } = contactUsSlice.actions;
export default contactUsSlice.reducer;
